import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IScanningPrefix, ScanningPrefixService } from '@shared/services/scanning-prefix.service';
import { ValidatorPatterns } from '@shared/validatorpatterns';

@Component({
	selector: 'app-create-scanning-prefix',
	templateUrl: './create-scanning-prefix.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateScanningPrefixComponent implements OnInit {
	@Output() created: EventEmitter<any> = new EventEmitter();
	scanningPrefix: IScanningPrefix;
	form: FormGroup;
	loading: boolean = false;
	httpError: string = '';

	constructor(
		public dialogRef: MatDialogRef<CreateScanningPrefixComponent>,
		private service: ScanningPrefixService,
		private fb: FormBuilder,
	) {
		this.scanningPrefix = { id: null, prefix: null };
	}

	ngOnInit(): void {
		this.initializeForm();
	}

	initializeForm(): void {
		this.form = this.fb.group({
			prefix: [this.scanningPrefix.prefix, [Validators.required, Validators.maxLength(255), Validators.pattern(ValidatorPatterns.RFIDCharacters)]],
		});
		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.scanningPrefix) {
					this.scanningPrefix[key] = value[key];
				}
			});
		});
	}

	get controls() {
		return this.form.controls;
	}

	onCancel = () => this.dialogRef.close();

	async onSave() {
		if (this.loading) return;
		this.httpError = '';

		if (this.form.valid) {
			this.loading = true;
			this.service.create(this.scanningPrefix).subscribe({
				next: (response) => {
					this.created.emit(response);
					this.dialogRef.close();
				},
				error: (errorResponse) => {
					this.httpError = `${errorResponse.status}`;
					this.loading = false;
				},
			});
		}
	}
}
